import graphqlClient from "@/GQLClient";
import { type CoreNewsAuthorFragment } from "@/graphql";
import {
  GetCoreNewsAuthorsDocument,
  SaveAuthorDocument,
  type CoreNewsAuthorInput,
} from "@/graphql/generated-types";
import type { FetchPolicy } from "@apollo/client";
import { GraphQLError } from "graphql";

const getAuthors = async (
  fetchPolicy: FetchPolicy = "no-cache",
): Promise<CoreNewsAuthorFragment[]> => {
  const response = await graphqlClient.query({
    query: GetCoreNewsAuthorsDocument,
    fetchPolicy,
  });

  if (response.data?.coreNews?.getAuthors) {
    return response.data?.coreNews.getAuthors as CoreNewsAuthorFragment[];
  }

  throw new GraphQLError(`api.authors.getAuthors`);
};

const save = async (author: CoreNewsAuthorInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveAuthorDocument,
    variables: {
      author,
    },
  });

  if (response.data?.coreNews?.saveAuthor?.success) {
    return response;
  }

  throw new GraphQLError(`api.authors.saveAuthor`);
};

export default {
  getAuthors,
  save,
};
